import React, { useEffect, useState, useCallback } from 'react'
import { Progress, message as $message } from 'antd'
import { poll } from '@/utils/utils'
import styles from './Dragger.less'
import { getProgress } from '@/services/progress'

const TaskProgress = ({
    content,
    id,
    onFinish,
    type = 'circle',
    pureClass = false,
    getProgressFunc,
    showProgress = true
}) => {
    const [percent, setPercent] = useState(0)
    const [res, setRes] = useState(null)
    const [errorMsg, setErrorMsg] = useState('')

    const fetch = useCallback(
        async run => {
            const res = await (getProgressFunc ? getProgressFunc(id) : getProgress(id))
            const { data, message, success } = res || {}
            if (success) {
                setPercent(data.percent)
                if (data?.finished) {
                    if (data.result && data.result.errorMsg) {
                        setErrorMsg(data.result.errorMsg)
                    }
                    setRes({ ...res.data, taskId: id })
                    return
                }
            }
            if (!success) {
                $message.error(message)
                setErrorMsg(message)
                return
            }

            run()
        },
        [id]
    )

    useEffect(() => {
        if (percent === 100 && res) {
            setTimeout(() => {
                onFinish({ ...res, taskId: id })
            }, 200)
        }
    }, [res, percent, onFinish, id])

    useEffect(() => {
        const clear = poll(fetch)

        return () => {

            clear()
        }
    }, [fetch])

    return (
        <div className={pureClass ? '' : styles.uploadWrap}>
            {showProgress && (
                <Progress
                    width={80}
                    status={errorMsg ? 'exception' : 'normal'}
                    type={type}
                    percent={percent}
                    strokeColor={
                        window.MASTER_PROJECT_CONFIG?.defaultSettings?.primaryColor ||
                        PROJECT_CONFIG?.defaultSettings?.primaryColor
                    }
                />
            )}
            {errorMsg ? <div style={{ color: '#ff4d4f' }}>{errorMsg}</div> : null}
            {typeof content === 'function' ? content(id, res) : content}
        </div>
    )
}

export default TaskProgress
